import { DateField, LocalizationProvider, CalendarIcon } from "@mui/x-date-pickers"
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import {
  isValid,
  parse as parseDate,
  startOfDay
} from "date-fns";
import { Box, IconButton, Popover, TextField } from "@mui/material";
import DatePicker from "react-datepicker";
import { useState, useEffect } from "react";
import { MIN_DATE } from '../utils/constants';

export function OverrideDatePicker({ overrideDate, setOverrideDate, fxType }) {
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [showValidation, setShowValidation] = useState(false);

  useEffect(() => {
    const onValidate = () => setShowValidation(true);
    const onClear = () => setShowValidation(false);
    window.addEventListener("validate-form", onValidate);
    window.addEventListener("clear-validation", onClear);
    return () => {
      window.removeEventListener("validate-form", onValidate);
      window.removeEventListener("clear-validation", onClear);
    };
  }, []);

  const handleOverrideDateChange = (date) => {
    const parsed = parseDate(date, "yyyy-MM-dd", new Date());
    if (isValid(parsed) && parsed >= MIN_DATE) {
      setOverrideDate(startOfDay(parsed));
    } else {
      setOverrideDate(null);
    }
  };

  const handleCalendarChange = (date) => {
    if (isValid(date) && date >= MIN_DATE) {
      setOverrideDate(startOfDay(date));
    }
    setOpen(false); // close on selection
  };

  if (fxType !== "Specific Date") return null;

  return (
    <Box display="flex" alignItems="center" gap={1}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DateField
          size="small"
          sx={{ width: 140 }}
          format="yyyy-MM-dd"
          required
          label="Override Date"
          value={overrideDate}
          onBlur={(newValue) => handleOverrideDateChange(newValue.target.value)}
          renderInput={(params) => (
            <TextField {...params} sx={{ width: "100%" }} error />
          )}
          error={(showValidation && !overrideDate) || !isValid(overrideDate) || overrideDate < MIN_DATE}
        />
      </LocalizationProvider>

      <IconButton
        color="primary"
        size="small"
        onClick={(event) => {
          setOpen(true);
          setAnchorEl(event.currentTarget);
        }}
      >
        <CalendarIcon />
      </IconButton>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={() => setOpen(false)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Box display="flex" justifyContent="center" alignItems="center" sx={{ p: 1 }}>
          <DatePicker
            inline
            selected={overrideDate}
            onChange={handleCalendarChange}
            dateFormat="yyyy-MM-dd"
            minDate={MIN_DATE}
            maxDate={new Date()}
            fixedHeight
            disabledKeyboardNavigation
          />
        </Box>
      </Popover>
    </Box>
  );
}
